import React from 'react'
import { Form, Row, Col, Dropdown } from 'react-bootstrap'

const Search = ({
  setSearchText,
  setCurrentPage,
  handleOnChange,
  searchText,
  setDigitsSearchType,
  roundDate,
  digitsSearchType,
  clearSearch,
  fetchLotteries,
  status,
  currentPage,
  lengthDigit,
  setLengthDigit,
}) => {
  const onSearch = () => {
    if (currentPage !== 1) {
      setCurrentPage(1)
    } else {
      fetchLotteries(currentPage, searchText, status, digitsSearchType, roundDate)
    }
  }

  return (
    <Form>
      <Row sm={12}>
        <Col sm={12} md={6} lg={6}>
          <div className="d-flex pt-2 pb-2">
            <input
              type="text"
              placeholder="เลขที่ต้องการ"
              value={searchText}
              maxLength={lengthDigit}
              className="form-control mr-2"
              style={{ color: '#5d5d5d' }}
              onChange={(e) => setSearchText(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  handleOnChange(e)
                }
              }}
            />
            <Col sm={12} md={6} lg={4}>
              {
                <Dropdown>
                  <Form.Control
                    as="select"
                    value={digitsSearchType}
                    onChange={(value) => {
                      setDigitsSearchType(() => value.target.value)
                      setSearchText('')
                      setLengthDigit(() =>
                        value.target.value === '' ? 6 : value.target.value === 'LAST_TWO_DIGITS' ? 2 : 3,
                      )
                    }}
                  >
                    <option value="">ทั้งหมด</option>
                    <option value="LAST_TWO_DIGITS">2 ตัวท้าย</option>
                    <option value="LAST_THREE_DIGITS">3 ตัวท้าย</option>
                    <option value="FIRST_THREE_DIGITS">3 ตัวหน้า</option>
                  </Form.Control>
                </Dropdown>
              }
            </Col>
          </div>
        </Col>
        <div
          className="btn btn-primary light align-self-center "
          style={{ minWidth: '120px' }}
          onClick={() => onSearch()}
        >
          ค้นหา
        </div>
        <div
          className="btn btn-primary light align-self-center"
          style={{ minWidth: '120px', marginLeft: '10px' }}
          onClick={() => clearSearch()}
        >
          ล้างการค้นหา
        </div>
      </Row>
    </Form>
  )
}

export default Search
